import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home, ChevronRight } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

// Global, reusable "back to Dashboard" control. Always returns to /app (the logged-in
// home / "Meu Natal"), never the public landing page. Optional simple breadcrumb.
// Props:
//   crumbs?: [{ label, to }]  intermediate levels (e.g. Receitas)
//   current?: string          current page label (not a link)
export default function BackToHome({ crumbs = [], current, className = "" }) {
  const { t } = useI18n();
  const hasCrumb = crumbs.length > 0 || current;

  return (
    <div className={`float-up mb-5 flex flex-wrap items-center gap-x-2 gap-y-1 ${className}`} data-testid="back-to-home">
      <Link
        to="/app"
        data-testid="back-to-home-link"
        className="inline-flex items-center gap-1.5 rounded-full border border-xmas-gold/25 bg-xmas-navycard/60 px-3.5 py-2 text-sm text-xmas-champagne transition hover:border-xmas-gold/60 hover:text-xmas-gold"
      >
        <ArrowLeft className="h-4 w-4" />
        <Home className="h-3.5 w-3.5" />
        <span>{t("nav.my_christmas")}</span>
      </Link>
      {hasCrumb && (
        <div className="ml-1 flex flex-wrap items-center gap-x-1.5 text-xs text-xmas-slate" data-testid="breadcrumb">
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3 text-xmas-slate/60" />
              {c.to ? <Link to={c.to} className="transition hover:text-xmas-champagne">{c.label}</Link> : <span>{c.label}</span>}
            </span>
          ))}
          {current && (
            <span className="flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3 text-xmas-slate/60" />
              <span className="text-xmas-champagne">{current}</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
}
